import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  constants: {
    CustomerStructure: [],
    ShopArea: [],
    ShopLayout: [],
    ShopLocation: [],
    ShopMaxPrice: [],
    ShopRanking: [],
    ShopSeasons: [],
    ShopStructureBrandLine: [],
    ShopStructureBrandName: [],
    ShopStructureLacosteLine: [],
    ShopStructureColmarLine: [],
    ShopStructureCategory: [],
    ShopStructureGender: [],
    ShopSurface: [],
    ShopWindows: [],
    ShopType: [],
  },
};

export const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    // Merged, not replaced: structure-types and shop-constants are fetched
    // from two independent, order-unpredictable requests (CustomerMapper.
    // hooks.ts) — a full replace here would wipe out whichever one already
    // landed once the other's response arrives.
    setConstants(state, action) {
      state.constants = { ...state.constants, ...action.payload };
    },
  },
});

export const getState = (rootState: RootState) => rootState.constants;

export const { setConstants } = constantsSlice.actions;
